export const category_main = 'category_main.js'
export const athletes_sexual_issues = 'athletes_sexual_issues.js'
export const bodybuilding_training = 'bodybuilding_training.js'
export const competitions = 'competitions.js'
export const introduction = 'introduction.js'
export const practice_with_kesh = 'practice_with_kesh.js'
export const psychology_motivation = 'psychology_motivation.js'
export const shading = 'shading.js'
export const sport_pathology = 'sport_pathology.js'
export const warm_up_exercises = 'warm_up_exercises.js'
export const technique = 'technique.js'
export const what_wrestler_should_know = 'what_wrestler_should_know.js'
export const nutrition_sports_supplements = 'nutrition_sports_supplements.js'
////////////////////////////////////////////////////////////////////////////////////////////////////

export const technique_undercover = 'technique_undercover.js'
export const technique_guarding = 'technique_guarding.js'
export const technique_yekdast_yekpa = 'technique_yekdast_yekpa.js'
export const technique_undercover_continue = 'technique_undercover_continue.js'
export const technique_prevalence = 'technique_prevalence.js'
export const technique_interception_defense = 'technique_interception_defense.js'
export const technique_head_and_neck = 'technique_head_and_neck.js'
export const technique_working_hands = 'technique_working_hands.js'
export const technique_sitting_on_buttocks = 'technique_sitting_on_buttocks.js'
export const technique_techniques_in_soil = 'technique_techniques_in_soil.js'
export const technique_standing_techniques = 'technique_standing_techniques.js'













